export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "RiderMasterImportWorker.063964d146f8165f56a2.worker.js");
}
